module.exports = __webpack_public_path__ + "static/clubes-651ea7229d56f4346db648e3735646c6.jpg";